<div class="video-container">
  <div class="thumbnail" #playButton [class.autoplay]="autoplay">
    <img src="{{ 'https://img.youtube.com/vi/' + streamKey + '/maxresdefault.jpg' }}" />
  </div>
  <div class="youtube-player">
    <div id="ytplayer_{{ streamKey }}"></div>
  </div>
</div>
